<div class="product-view-container">
	<nav class="product-header sticky-top navbar navbar-light bg-light" [ngClass]="{ 'im-dirty': isModified }">
		<span class="navbar-brand">Add State</span>
		<div class="navbar-nav mr-auto"></div>
		<button type="button" class="btn btn-secondary btn-cancel mr-3" [routerLink]="['/regional/states']">
			<span>Cancel</span>
		</button>
		<button type="button" class="btn btn-primary btn-save" (click)="save()">
			<span>Save</span>
		</button>
		<button mat-icon-button class="btn-close" (click)="back()">
			<mat-icon>close</mat-icon>
		</button>
	</nav>
	<div class="product-container">
		<mat-card>
			<div class="row">
				<div class="col-8">
					<label>State Name</label>
					<div class="input-group mb-3">
						<input [(ngModel)]="state.name" type="text" class="form-control" (input)="dataChanged()">
					</div>
					<label>State Code</label>
					<div class="input-group mb-3">
						<input [(ngModel)]="state.code" type="text" class="form-control" (input)="dataChanged()"
							placeholder="Ex: NCR">
					</div>
					<label>Courier</label>
					<select [(ngModel)]="state.courierId" name="courierId" class="custom-select" required>
						<option value="0">Select a courier</option>
						<option *ngFor="let courier of couriers" value="{{courier.id}}">{{ courier.name }}</option>
					</select>
					<label>Description</label>
					<div class="input-group mb-3">
						<textarea [(ngModel)]="state.description" class="form-control" rows="5"
							(input)="dataChanged()"></textarea>
					</div>
				</div>
			</div>
		</mat-card>
	</div>
</div>